import { FC } from 'react';
import Text from '@/Components/atoms/Text';
interface Props {
  type: string;
  price: number;
}
import './Price.scss';
import { useTranslation } from 'react-i18next';

const Price: FC<Props> = props => {
  const { t } = useTranslation();

  return (
    <div className={`price ${props.type}`}>
      <Text type="span" children={`${props.price}`} />
      <Text type="span" children={t('GENERAL.EURO_MONTH')} />
    </div>
  );
};

export { Price };
